<div class="section" style="flex-basis: 40%; padding-left: 40px; border-right: 1px solid #EEE">
  <div *ngIf="isRequirementsLoaded" style="position: fixed;z-index: 1;left: calc(40% - 80px);">
    <button mat-fab color="accent" matTooltip="Download image of wireframe" aria-label="Download image of wireframe" (click)="downloadWireframe()">
      <mat-icon>download</mat-icon>
    </button>
  </div>
  <p style="width: calc(100% - 60px)">Please select your options for the following features of the checkout webpage shown on the right.</p>
  <p *ngIf="this.variant === '6' || this.variant === '21'">As explained in the survey, selections you make for some of the features listed below may not be applied to the interface design on the right.</p>
  <p style="width: calc(100% - 60px)">After completing the above task, <b>download the image of the webpage</b> using the yellow download button on top and then immediately <b>return to the Qualtrics survey</b>. You will be asked to upload the image of the webpage in the survey.</p>
  <br />

  <div
    *ngFor="let requirement of requirements; let i = index"
    style="margin-bottom: 20px;"
  >
    <p style="display: block;" [innerHTML]="(i+1) + '. ' + requirement.text"></p>
    <!-- <p style="display: block;" [innerHTML]="requirement.subtitle"></p> -->
    <mat-radio-group
      aria-label="Select an option"
      style="display: flex; flex-direction: column;"
    >
      <mat-radio-button
        [value]="requirement.id+''+(j+1)"
        *ngFor="let option of requirement.options; let j = index"
        style="margin: 5px;"
        (change)="this.handleClick(requirement.id, i, j, optionDiv)"
        [disabled]="this.isDisabled(i, j)"
      >
      <!-- [checked]="this.preselectedOptions[i] === j" -->
        <div #optionDiv [innerHtml]="option" [ngClass]="{'disabled': this.isDisabled(i, j)}"></div>
      </mat-radio-button>
    </mat-radio-group>
  </div>
  <mat-spinner *ngIf="!isRequirementsLoaded" color="accent" diameter="60" style="margin: 0 auto;"></mat-spinner>
</div>
<div class="section" style="flex-basis: 60%;">
  <object
    id="wireframe"
    data="assets/Wireframe.svg"
    type="image/svg+xml"
    style="width: calc(100% - 20px); /*max-height: 95vh;*/"
  ></object>
</div>



<router-outlet></router-outlet>
